<template>
  <div class="page">
    <div class="bosch_logo">
      <img src="../../assets/images/sp-questionnaire1.png" />
    </div>
    <div class="content">

<div class="second-part">

          <div class="info-text">
          <h3>欢迎！</h3>
          <br/>
            <p>欢迎您参与本次调研！本次调研活动不会占用您超过五分钟的时间。您的反馈对于我们而言十分重要。您的意见和建议将会帮助我们改进未来博世火花塞的销售。您的回答将会被严格保密。</p>
          <br/>
          <br/>
        </div>

      <div v-for="(option, index) in optionList" :key="index">
        <div style="background-color:#ffffff; margin-bottom:15px;border-radius:2px">
          <div class="bar_title">
            <div class="title-icon">
              <img src="../../assets/images/header-icon.png"/>
              <span>{{ index + 1}}</span>
            </div>
            <div class="title">
              <span>{{ option.title }}</span>
            </div>

            <div class="questionType" v-show="option.questionType !== '04'">{{ typeText(option.questionType,option.type) }}</div>
          </div>
          <!-- 单选 -->
          <div v-if="option.questionType === '01'">
            <!-- 单选没有文本框 -->
            <div v-if="!option.starType">
              <van-radio-group v-model="option.index">
                <van-cell-group>
                  <van-cell v-for="(item, i) in option.item" :key="i" :name="i">
                    <van-radio :name="i">{{ item.optionName }}</van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
            <!-- 单选含有文本框 -->
            <div v-if="option.starType === 'input'">
              <van-radio-group v-model="option.index" @change="option.content = ''">
                <van-cell-group>
                  <van-cell v-for="(item, idx) in option.item"
                      :key="idx"
                      :label="idx">
                    <van-radio :name="idx" >
                      {{ item.optionName }}
                    </van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <van-cell v-show="option.item && option.index === option.item.length - 1">
                <van-field v-model="option.content"

                      :placeholder="option.tip"
                      clearable>
                  </van-field>
              </van-cell>
              <van-cell v-show="option.special">
                <van-field v-model="option.content"
                      v-show=" option.item && option.index === option.item.length - 2"
                      :placeholder="option.specialTip"
                      clearable>
                  </van-field>
              </van-cell>
            </div>
          </div>
          <!-- 多选 -->
          <div v-if="option.questionType === '02'">
            <!--排序-->
            <div v-if="option.type==='rank'">
              <van-cell-group>
                <van-cell class="rank"
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <span class="optionName">{{item.optionName}}</span>
                  <span class="rank-input">(
                    <van-field v-model="item.value"  @change.native="handleInputChange($event,index,i,option.item.length)"  />
                  )
                     </span>

                </van-cell>
              </van-cell-group>
            </div>

            <!--选 是或者否 -->
            <div v-if="option.type === 'select'">
              <van-cell-group>
                <div v-for="(item, i) in option.item" :key="i" >
                  <div v-if="i!==option.item.length-1" class="type02-select">

                <van-cell
                   :name="i"
                  clickable :title="item.optionName " >
                   <template #default>
                    <van-radio-group v-model="item.value"  >
                      <van-radio name="否">否</van-radio>
                      <van-radio name="是">是</van-radio>
                    </van-radio-group>
                   </template>
                </van-cell>

                  </div>

                <div v-else class="type02-select-input">
                  <van-cell>
                    <van-field v-model="item.title"
                      :placeholder="item.optionName"
                      clearable>
                    </van-field>

                   <van-radio-group v-model="item.value"  >
                      <van-radio name="否">否</van-radio>
                      <van-radio name="是">是</van-radio>
                    </van-radio-group>
                  </van-cell>
                </div>

                <!-- <van-cell
                   :name="i"
                  clickable  v-else>

                   <template #default>
                     <van-field v-model="item.title" placeholder="请输入用户名" />
                    <van-radio-group v-model="item.value"  >
                      <van-radio name="否">否</van-radio>
                      <van-radio name="是">是</van-radio>
                    </van-radio-group>
                   </template>
                </van-cell> -->

                </div>
              </van-cell-group>
            </div>

              <!--多选含文本框-->
            <div v-if="option.type === 'input'">

              <van-checkbox-group v-model="option.list"  :max="option.max">
                <van-cell-group>
                  <van-cell
                    v-for="(item, i) in option.item"
                    :key="i" :name="i"
                    clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
                </van-cell-group>

                <van-cell>
                  <van-field v-model="option.questionAnswer"
                      v-show="option.item && option.list.indexOf(option.item.length-1)!==-1"
                      :placeholder="option.tip"
                      clearable>
                  </van-field>
                </van-cell>
              </van-checkbox-group>
            </div>

              <!--默认 多选-->
            <div v-if="!option.type">
             <van-checkbox-group  v-model="option.list">
              <van-cell-group>
                <van-cell
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
              </van-cell-group>
             </van-checkbox-group>

              </div>

          </div>

          <!-- 问答 -->
          <div v-if="option.questionType === '04'">

          <div style="padding: 0 10px 10px 10px;" class="score-field">
            <van-field
              v-model="option.questionAdvice"
              type="textarea"
              :placeholder="option.tip"
              autosize
              clearable
            ></van-field>

           <div v-if="option.type==='select'">
              <div class="userType-title">
                {{ option.itemTitle }}
              </div>
              <van-checkbox-group v-model="option.list" :max="3">
                <van-cell-group>
                  <van-cell
                    v-for="(item, i) in option.item"
                    :key="i" :name="i"
                    clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
                </van-cell-group>

                <van-cell>
                  <van-field v-model="option.itemQuestionAdvice"
                      v-show="option.item && option.list.indexOf(option.item.length-1)!==-1"
                      :placeholder="option.itemTip"
                      clearable>
                  </van-field>
                </van-cell>
              </van-checkbox-group>
            </div>
          </div>
          </div>

        </div>
      </div>

          <div class="info-text" style="height:50px">
           <p>调研已结束。感谢您的配合！我们十分重视您的反馈。如果您有任何疑问或意见，请联系：李书亮 021-22188790</p>
          <br/>
          <br/>
        </div>

      <div class="submit-btn">
        <van-button :loading="loading" type="info" size="normal" round @click="handleSubmit">提 交</van-button>
      </div>
    </div>

</div>

    <!-- 弹窗 -->
    <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
      <div class="msg-text">感谢您参与本次问卷</div>
      <div class="msg-text" style="margin-top: 5px;">奖励积分已发放至您的账户</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>

    <van-popup v-model="popShow2" class="msg-pop msg-pop-join" :close-on-click-overlay="false">
      <div class="msg-text">您已参加过本次问卷调查</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
    <!-- 弹窗-不能参加 -->
    <van-popup v-model="popShow3" class="msg-pop msg-pop-error" :close-on-click-overlay="false">
      <div class="msg-text">本活动仅限IAM和OES客户参加</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { Toast } from 'vant'
import { commonUtils } from '@/utils/common'
export default {
  name: 'Questionnaire',
  data () {
    return {
      loading: false,
      clientCode: '',
      userType: {
        title: '请问您属于：',
        questionCode: '001-01',
        questionType: '01',
        optionCode: '',
        optionName: '',
        index: -1,
        selectedOptionCode: '',
        item: [
          { optionCode: '001-01-01', optionName: '经销商' },
          { optionCode: '001-01-02', optionName: '批发商（二批或经销商门店）' },
          { optionCode: '001-01-03', optionName: '修理厂' }
        ]
      },
      optionListHead: [
        {
          title: '请问您的姓名：',
          questionCode: '001-02',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入您的姓名',
          optionCode: '001-02-01',
          starType: ''
        },
        {
          title: '请问您的职位：',
          questionCode: '001-03',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入您的职位',
          optionCode: '001-03-01',
          starType: ''
        },
        {
          title: '请问您的所在公司名称：',
          questionCode: '001-04',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入您的所在公司名称',
          optionCode: '001-04-01',
          starType: ''
        }
      ],
      optionListFoot: [
        {
          title: '请问您销售的火花塞用于以下哪种车辆？',
          questionCode: '001-08',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-08-01', optionName: '乘用车' },
            { optionCode: '001-08-02', optionName: '商用车' },
            { optionCode: '001-08-03', optionName: '小汽油机（园林机械）' }
          ]
        },
        {
          title: '请问哪种类型的促销活动最能够打动您？(请按优先级依次输入数字1-7)',
          questionCode: '001-09',
          questionType: '02',
          type: 'rank',
          list: [],
          item: [
            { optionCode: '001-09-01', optionName: '产品促销' },
            { optionCode: '001-09-02', optionName: '产品商务和返利政策' },
            { optionCode: '001-09-03', optionName: '一年内稳定价格（一年内价格不变）' },
            { optionCode: '001-09-04', optionName: '客户服务支持平台（如：易加网）' },
            { optionCode: '001-09-05', optionName: '售出支持活动' },
            { optionCode: '001-09-06', optionName: '与博世其它产品捆绑销售' },
            { optionCode: '001-09-07', optionName: '销售工具提供（如：展板、展架等）' }
          ]
        },
        {
          title: '请问您认为博世火花塞在以下方面是否具有竞争力？(请在每一项下选择“是”或者“否”)',
          questionCode: '001-10',
          questionType: '02',
          type: 'select',
          list: [],
          item: [
            { optionCode: '001-10-01', optionName: '修理厂零售价', value: '' },
            { optionCode: '001-10-02', optionName: '经销商/批发价格', value: '' },
            { optionCode: '001-10-03', optionName: '产品品质', value: '' },
            { optionCode: '001-10-04', optionName: '产品包装', value: '' },
            { optionCode: '001-10-05', optionName: '利润', value: '' },
            { optionCode: '001-10-06', optionName: '车型覆盖率', value: '' },
            { optionCode: '001-10-07', optionName: '产品易得性', value: '' },
            { optionCode: '001-10-08', optionName: '其它请注明', value: '', title: '' }
          ]
        },
        {
          title: '请问您平常使用哪种产品目录？',
          questionCode: '001-11',
          questionType: '01',
          questionAnswer: '',
          index: -1,
          content: '',
          tip: '其它请注明',
          special: true,
          specialTip: '请注明在线目录名称',
          starType: 'input',
          item: [
            { optionCode: '001-11-01', optionName: '纸质目录' },
            { optionCode: '001-11-02', optionName: '在线目录，请注明' },
            { optionCode: '001-11-03', optionName: '其它请注明' }
          ]
        },
        {
          title: '火花塞包装，选择4支装（参考每辆车的发动机缸数）还是10支装，请进行选择',
          questionCode: '001-12',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-12-01', optionName: '4支装/盒' },
            { optionCode: '001-12-02', optionName: '10支装/盒' }
          ]
        },
        {
          title: '请列出最影响您增加博世火花塞订购量的因素，您认为博世火花塞在哪些方面有待改进？',
          questionCode: '001-13',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入改进内容',
          optionCode: '001-13-01',
          starType: ''
        },
        {
          title: '如果您还有其它意见，请在这里添加',
          questionCode: '001-14',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入其它意见',
          optionCode: '001-14-01',
          starType: ''
        }
      ],
      optionListType01: [
        // {
        //   title: '请问您认为博世火花塞在以下方面是否具有竞争力？(请在每一项下选择“是”或者“否”)',
        //   questionCode: '001-10',
        //   questionType: '02',
        //   type: 'select',
        //   list: [],
        //   item: [
        //     { optionCode: '001-10-01', optionName: '修理厂零售价', value: '' },
        //     { optionCode: '001-10-02', optionName: '经销商/批发价格', value: '' },
        //     { optionCode: '001-10-03', optionName: '产品品质', value: '' },
        //     { optionCode: '001-10-04', optionName: '产品包装', value: '' },
        //     { optionCode: '001-10-05', optionName: '利润', value: '' },
        //     { optionCode: '001-10-06', optionName: '车型覆盖率', value: '' },
        //     { optionCode: '001-10-07', optionName: '产品易得性', value: '' },
        //     { optionCode: '001-10-08', optionName: '其它请注明', value: '' }
        //   ]
        // },

        {
          title: '当购买博世火花塞时，您会考虑哪些因素？请选择三个您认为最重要的决策因素。（只能选择三项）',
          questionCode: '001-06',
          questionType: '02',
          questionAnswer: '',
          tip: '其它请注明',
          type: 'input',
          max: 3,
          maxRequired: true,
          list: [],
          item: [
            { optionCode: '001-06-01', optionName: '原厂配套' },
            { optionCode: '001-06-02', optionName: '产品质量和外观' },
            { optionCode: '001-06-03', optionName: '价格和折扣' },
            { optionCode: '001-06-04', optionName: '促销活动和激励政策' },
            { optionCode: '001-06-05', optionName: '供应商支持' },
            { optionCode: '001-06-06', optionName: '车型覆盖率' },
            { optionCode: '001-06-07', optionName: '产品号码查询便捷度' },
            { optionCode: '001-06-08', optionName: '产品型号和号码易懂易记忆（类似短码）' },
            { optionCode: '001-06-09', optionName: '赛事活动' },
            { optionCode: '001-06-10', optionName: '产品信息易得（如图片、产品描述、包装和产品图片等）' },
            { optionCode: '001-06-11', optionName: '数据质量（产品适配信息，数据系统对接等）' },
            { optionCode: '001-06-12', optionName: '在线产品目录' },
            { optionCode: '001-06-13', optionName: '退款政策是否简单快速' },
            { optionCode: '001-06-14', optionName: '保修政策' },
            { optionCode: '001-06-15', optionName: '其它请注明' }
          ]
        },
        {
          title: '除了博世火花塞之外，您销售的其它品牌火花塞为哪个品牌？',
          questionCode: '001-08',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入您销售的其它品牌火花塞',
          optionCode: '001-02-01',
          starType: '',
          type: 'select',
          selectHasInput: true,
          max: 3,
          list: [],
          itemTitle: '选择这个品牌您认为的主要优势?(最多选择三项)',
          itemTip: '请输入您认为的其它优势',
          itemQuestionAdvice: '',
          item: [
            { optionCode: '001-08-01', optionName: '原厂配套' },
            { optionCode: '001-08-02', optionName: '产品质量和外观' },
            { optionCode: '001-08-03', optionName: '价格和折扣' },
            { optionCode: '001-08-04', optionName: '车型覆盖率' },
            { optionCode: '001-08-05', optionName: '促销活动、激励政策' },
            { optionCode: '001-08-06', optionName: '供应商产品交货时间' },
            { optionCode: '001-08-07', optionName: '修理厂员工支持方案' },
            { optionCode: '001-08-08', optionName: '客户服务支持平台（如：易加网）' },
            { optionCode: '001-08-09', optionName: '产品号码查询便捷度' },
            { optionCode: '001-08-10', optionName: '经销商/批发商推荐' },
            { optionCode: '001-08-11', optionName: '产品型号和号码易懂易记忆（类似短码）' },
            { optionCode: '001-08-12', optionName: '易获取，经销商/批发商是否有现货' },
            { optionCode: '001-08-13', optionName: '赛事活动' },
            { optionCode: '001-08-14', optionName: '产品信息易得（如图片、产品描述、包装和产品图片等）' },
            { optionCode: '001-08-15', optionName: '数据质量（产品适配信息，数据系统对接等）' },
            { optionCode: '001-08-16', optionName: '在线产品目录' },
            { optionCode: '001-08-17', optionName: '退款政策是否简单快速' },
            { optionCode: '001-08-18', optionName: '保修政策' },
            { optionCode: '001-08-19', optionName: '其它请注明' }
          ]
        }
        // {
        //   title: '除了博世火花塞之外，您销售的其它品牌火花塞为哪个品牌？',
        //   questionCode: '001-08',
        //   questionType: '02',
        //   questionAnswer: '',
        //   questionMixAnswer: '',
        //   tip: '请告知其他倾向',
        //   type: 'input',
        //   mix: true,
        //   list: [],
        //   itemTitle: '选择这个品牌您认为的主要优势?(最多选择三项)',
        //   item: [
        //     { optionCode: '001-08-01', optionName: '原厂配套' },
        //     { optionCode: '001-08-02', optionName: '产品质量和外观' },
        //     { optionCode: '001-08-03', optionName: '价格和折扣' },
        //     { optionCode: '001-08-04', optionName: '车型覆盖率' },
        //     { optionCode: '001-08-05', optionName: '促销活动、激励政策' },
        //     { optionCode: '001-08-06', optionName: '供应商产品交货时间' },
        //     { optionCode: '001-08-07', optionName: '修理厂员工支持方案' },
        //     { optionCode: '001-08-08', optionName: '客户服务支持平台（如：易加网）' },
        //     { optionCode: '001-08-09', optionName: '产品号码查询便捷度' },
        //     { optionCode: '001-08-10', optionName: '经销商/批发商推荐' },
        //     { optionCode: '001-08-11', optionName: '产品型号和号码易懂易记忆（类似短码）' },
        //     { optionCode: '001-08-12', optionName: '易获取，经销商/批发商是否有现货' },
        //     { optionCode: '001-08-13', optionName: '赛事活动' },
        //     { optionCode: '001-08-14', optionName: '产品信息易得（如图片、产品描述、包装和产品图片等）' },
        //     { optionCode: '001-08-15', optionName: '数据质量（产品适配信息，数据系统对接等）' },
        //     { optionCode: '001-08-16', optionName: '在线产品目录' },
        //     { optionCode: '001-08-17', optionName: '退款政策是否简单快速' },
        //     { optionCode: '001-08-18', optionName: '保修政策' },
        //     { optionCode: '001-08-19', optionName: '其它请注明' }
        //   ]
        // }
      ],
      optionListType2: [
        {
          title: '请问您属于：',
          questionCode: '001-05',
          questionType: '01',
          questionAnswer: '',
          index: -1,
          content: '',
          tip: '其它请注明',
          starType: 'input',
          item: [
            { optionCode: '001-05-01', optionName: '博世车联' },
            { optionCode: '001-05-02', optionName: '连锁修理厂' },
            { optionCode: '001-05-02', optionName: '独立修理厂' },
            { optionCode: '001-05-03', optionName: '其它请注明' }
          ]
        },
        {
          title: '当购买博世火花塞时，您会考虑哪些因素？请选择三个您认为最重要的决策因素。（只能选择三项）',
          questionCode: '001-06',
          questionType: '02',
          questionAnswer: '',
          tip: '其它请注明',
          type: 'input',
          max: 3,
          maxRequired: true,
          list: [],
          item: [
            { optionCode: '001-06-01', optionName: '原厂配套' },
            { optionCode: '001-06-02', optionName: '产品质量和外观' },
            { optionCode: '001-06-03', optionName: '价格和折扣' },
            { optionCode: '001-06-04', optionName: '车型覆盖率' },
            { optionCode: '001-06-05', optionName: '促销活动、激励政策' },
            { optionCode: '001-06-06', optionName: '供应商产品交货时间' },
            { optionCode: '001-06-07', optionName: '修理厂员工支持方案' },
            { optionCode: '001-06-08', optionName: '客户服务支持平台（如：易加网）' },
            { optionCode: '001-06-09', optionName: '产品号码查询便捷度' },
            { optionCode: '001-06-10', optionName: '经销商/批发商推荐' },
            { optionCode: '001-06-11', optionName: '产品型号和号码易懂易记忆（类似短码）' },
            { optionCode: '001-06-12', optionName: '易获取，经销商/批发商是否有现货' },
            { optionCode: '001-06-13', optionName: '赛事活动' },
            { optionCode: '001-06-14', optionName: '产品信息易得（如图片、产品描述、包装和产品图片等）' },
            { optionCode: '001-06-15', optionName: '数据质量（产品适配信息，数据系统对接等）' },
            { optionCode: '001-06-16', optionName: '在线产品目录' },
            { optionCode: '001-06-17', optionName: '退款政策是否简单快速' },
            { optionCode: '001-06-18', optionName: '保修政策' },
            { optionCode: '001-06-19', optionName: '其它请注明' }
          ]
        },
        {
          title: '除了博世火花塞之外，您销售的其它品牌火花塞为哪个品牌？',
          questionCode: '001-07',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入您销售的其它品牌火花塞',
          optionCode: '001-07-00',
          starType: '',
          isSpecialStyle: true,
          type: 'select',
          selectHasInput: true,
          max: 3,
          list: [],
          itemTitle: '选择这个品牌您认为的主要优势?(最多选择三项)',
          itemTip: '请输入您认为的其它优势',
          itemQuestionAdvice: '',
          item: [
            { optionCode: '001-07-01', optionName: '原厂配套' },
            { optionCode: '001-07-02', optionName: '产品质量和外观' },
            { optionCode: '001-07-03', optionName: '价格和折扣' },
            { optionCode: '001-07-04', optionName: '车型覆盖率' },
            { optionCode: '001-07-05', optionName: '促销活动、激励政策' },
            { optionCode: '001-07-06', optionName: '供应商产品交货时间' },
            { optionCode: '001-07-07', optionName: '修理厂员工支持方案' },
            { optionCode: '001-07-08', optionName: '客户服务支持平台（如：易加网）' },
            { optionCode: '001-07-09', optionName: '产品号码查询便捷度' },
            { optionCode: '001-07-10', optionName: '经销商/批发商推荐' },
            { optionCode: '001-07-11', optionName: '产品型号和号码易懂易记忆（类似短码）' },
            { optionCode: '001-07-12', optionName: '易获取，经销商/批发商是否有现货' },
            { optionCode: '001-07-13', optionName: '赛事活动' },
            { optionCode: '001-07-14', optionName: '产品信息易得（如图片、产品描述、包装和产品图片等）' },
            { optionCode: '001-07-15', optionName: '数据质量（产品适配信息，数据系统对接等）' },
            { optionCode: '001-07-16', optionName: '在线产品目录' },
            { optionCode: '001-07-17', optionName: '退款政策是否简单快速' },
            { optionCode: '001-07-18', optionName: '保修政策' },
            { optionCode: '001-07-19', optionName: '其它请注明' }
          ]
        }
      ],
      optionList: [],
      initList: [],
      rageScore: 6,
      userInfo: {},
      popShow: false,
      popShow2: false,
      popShow3: false,
      currentIndex: [],
      currentRadio: [],
      count: 0,
      rankObj: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.initList = []
      this.resetForm(this.initList, this.optionList)

      // if (this.$route.query.userType === 0 || this.$route.query.userType === 1) {
      //   this.userType.optionCode = this.$route.query.userType === 0 ? '001-01-01' : '001-01-02'
      //   this.userType.optionName = this.$route.query.userType === 0 ? '经销商' : '批发商（二批或经销商门店）'
      //   this.optionList = this.optionListHead.concat(this.optionListType01).concat(this.optionListFoot)
      // } else if (this.$route.query.userType === 2) {
      //   this.userType.optionCode = '001-01-03'
      //   this.userType.optionName = '修理厂'
      //   this.optionList = this.optionListHead.concat(this.optionListType2).concat(this.optionListFoot)
      // }

      this.userType.optionCode = '001-01-03'
      this.userType.optionName = '修理厂'
      this.optionList = this.optionListHead.concat(this.optionListType2).concat(this.optionListFoot)
    },
    isJoined () {
      const questionnaireCode = '004'
      activityApi.isJoinedQuestionnaire(questionnaireCode).then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.questionnaireRecordList.length) {
            this.popShow2 = true
          } else {
            this.popShow2 = false
          }
        }
      })
    },
    typeText (type, type2) {
      if (type2 === 'rank') {
        return '排序'
      } else {
        switch (type) {
          case '01': return '单选'
          // case '02': return '多选'
          case '03': return '单选'
        }
      }
    },

    /** 选择分数 */
    chooseScore (item, i, index) {
      this.currentIndex = []
      this.optionList[index].selectedRateCode = item.rateCode
      this.optionList.forEach(item => {
        if (item.selectedRateCode) {
          this.currentIndex.push(item.selectedRateCode)
        }
      })
      this.optionList[index].rateValue = i + 1
    },

    handleInputChange (e, index, i, length) {
      let value = e.target.value
      let arr = []
      for (let num = 1; num < length + 1; num++) {
        arr.push('' + num)
      }
      // let arr = ['1', '2', '3', '4', '5']
      let arrList = []
      for (let item in this.rankObj) {
        // console.log(this.rankObj[i]);
        arrList.push(this.rankObj[item])
      }
      if (arr.indexOf(value) === -1 && value !== '') {
        Toast.fail(`请输入1~${length}间的数字`)
        console.log(this.optionList[index].item[i].value)
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
      } else if (arrList.indexOf(value) !== -1 && value !== '') {
        Toast.fail('输入数字重复')
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
        // e.target.value = ''
      } else if (value === '') {
        this.rankObj[i] = ''
        arrList[i] = ''
      } else {
        this.rankObj[i] = value
      }
    },

    handleSubmit () {
      const params = {
        questionnaireCode: '004',
        clientCode: this.clientCode,
        questionnaireList: []
      }

      params.questionnaireList.push({
        questionCode: this.userType.questionCode,
        questionType: this.userType.questionType,
        optionCode: this.userType.optionCode,
        optionName: this.userType.optionName,
        questionAnswer: this.userType.optionName,
        optionDesc: ''
      })

      let flag = false
      for (let j = 0; j < this.optionList.length; j++) {
        // 单选
        if (this.optionList[j].questionType === '01' && !this.optionList[j].starType) {
          if (this.optionList[j].index < 0) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
            optionName: this.optionList[j].item[this.optionList[j].index].optionName,
            questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
            optionDesc: ''
          })
        }

        // 单选中有文本框
        if (this.optionList[j].questionType === '01' && this.optionList[j].starType === 'input') {
          if (this.optionList[j].index < 0 || (this.optionList[j].index === this.optionList[j].item.length - 1 && !this.optionList[j].content) || (this.optionList[j].index === this.optionList[j].item.length - 2 && !this.optionList[j].content)) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          // 如果选择单选框
          if (this.optionList[j].index >= 0 && !this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].index].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
              optionDesc: ''
            })
          }

          if (this.optionList[j].special && this.optionList[j].content && this.optionList[j].index === 1) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].item.length - 2].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].item.length - 2].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 2].optionName,
              optionDesc: this.optionList[j].content
            })
          } else if (this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              optionDesc: this.optionList[j].content
            })
          }
        }

        // 多选
        if (this.optionList[j].questionType === '02') {
          if (this.optionList[j].max && this.optionList[j].maxRequired) {
            if (this.optionList[j].list.length !== this.optionList[j].max) {
              Toast.fail(`第${j + 1}题需要选择${this.optionList[j].max}个选项`)
              return
            }
          }
          // 排序
          if (this.optionList[j].type === 'rank') {
            for (let i of this.optionList[j].item) {
              if (!i.value) {
                console.log(j + 1)
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                return
              }
            }
            this.optionList[j].item.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: i.optionCode,
                optionName: i.optionName,
                questionAnswer: i.value,
                optionDesc: ''
              })
            })
          } else if (this.optionList[j].type === 'select') {
            for (let i of this.optionList[j].item) {
              console.log(i)
              if (i !== undefined) {
                console.log(i.title)
                if (i.title !== '' && i.value === '') {
                  console.log(i.title)
                  Toast.fail(`第${j + 1}题必填`)
                  return
                }
              } else {
                if (i.value === '') {
                  Toast.fail(`第${j + 1}题必填`)
                  return
                }
              }
            }
            this.optionList[j].item.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: i.optionCode,
                optionName: i.optionName,
                questionAnswer: i.value,
                optionDesc: ''
              })
            })
          } else if (this.optionList[j].type === 'input') {
            console.log(this.optionList[j].questionAnswer)
            console.log(this.optionList[j].list.length)

            if (!this.optionList[j].list.length) {
              Toast.fail(`第${j + 1}题必填`)
              flag = true
              break
            }

            if ((this.optionList[j].list.indexOf(this.optionList[j].item.length - 1) !== -1 && this.optionList[j].questionAnswer === '')) {
              Toast.fail(`第${j + 1}题必填`)
              flag = true
              break
            }
            this.optionList[j].list.forEach(i => {
              if (this.optionList[j].list.indexOf(this.optionList[j].item.length - 1) !== -1 && i === this.optionList[j].item.length - 1) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                  questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 1].questionAnswer,
                  optionDesc: this.optionList[j].questionAnswer
                })
              } else {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[i].optionCode,
                  optionName: this.optionList[j].item[i].optionName,
                  questionAnswer: this.optionList[j].item[i].optionName,
                  optionDesc: ''
                })
              }
            })
          } else {
            if (!this.optionList[j].list.length) {
              Toast.fail(`第${j + 1}题必填`)
              flag = true
              break
            }
            this.optionList[j].list.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[i].optionCode,
                optionName: this.optionList[j].item[i].optionName,
                questionAnswer: this.optionList[j].item[i].optionName,
                optionDesc: ''
              })
            })
          }
        }

        // 问答
        if (this.optionList[j].questionType === '04') {
          if (this.optionList[j].questionAdvice === '') {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }

          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].optionCode,
            optionName: this.optionList[j].tip,
            questionAnswer: this.optionList[j].questionAdvice,
            optionDesc: ''
          })

          if (this.optionList[j].type === 'select') {
            if (this.optionList[j].list.length === 0) {
              Toast.fail(`第${j + 1}题必填`)
              flag = true
              break
            }
            // 多选不包含输入框
            if (!this.optionList[j].selectHasInput) {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                questionAnswer: this.optionList[j].itemQuestionAdvice,
                optionDesc: ''
              })
            } else {
              // 多选包含输入框
              console.log(this.optionList[j].list.indexOf(this.optionList[j].item.length - 1))
              if (this.optionList[j].list.indexOf(this.optionList[j].item.length - 1) !== -1 && this.optionList[j].itemQuestionAdvice === '') {
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                break
              }
              this.optionList[j].list.forEach(i => {
                if (i === this.optionList[j].item.length - 1) {
                  console.log(this.optionList[j].item[i].itemQuestionAdvice)
                  params.questionnaireList.push({
                    questionCode: this.optionList[j].questionCode,
                    questionType: this.optionList[j].questionType,
                    optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                    optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                    questionAnswer: this.optionList[j].itemQuestionAdvice,
                    optionDesc: this.optionList[j].itemQuestionAdvice
                  })
                } else {
                  params.questionnaireList.push({
                    questionCode: this.optionList[j].questionCode,
                    questionType: this.optionList[j].questionType,
                    optionCode: this.optionList[j].item[i].optionCode,
                    optionName: this.optionList[j].item[i].optionName,
                    questionAnswer: this.optionList[j].item[i].optionName,
                    optionDesc: ''
                  })
                }
              })
            }
          }
        }
      }
      if (flag) {
        return
      }
      console.log(params)
      this.loading = true
      activityApi.submitQuestionnaire(params).then(response => {
        if (response.data.resultCode === '0') {
          this.popShow = true
          this.clientCode = ''
        } else {
          Toast.fail(response.data.resultMsg)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetForm (initArr, optionArr) {
      optionArr.forEach(option => {
        const obj = Object.assign({}, option)
        initArr.push(obj)
      })
    },
    handleRateChange (option) {
      if (option.questionAnswer > this.rageScore - 1) {
        option.index = -1
        option.content = ''
      }
    },
    popJump () {
      window.location.href = commonUtils.getExtraSite() + '/#/tab/home'
    },
    onChange (value) {
      Toast('当前值：' + value)
    },
    showNextPart () {
      this.isFirstPart = false
      this.optionListHead = this.optionListHead.concat(this.optionListFoot)
      console.log(this.optionListHead)
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 0;
  background: #fff;
  /deep/ .van-radio__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-checkbox__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-radio__label {
    color: #333;
  }
  /deep/ .type02-select .van-radio,.type02-select-input .van-radio{
    flex: 1;
    padding: 0;
    margin:0;
  }
  /deep/ .type02-select .van-radio-group,.type02-select-input .van-radio{
    display: flex;
  }
  /deep/ .type02-select .van-cell__value{
    left: 35px;
  }
    /deep/ .type02-select-input .van-radio-group{
    display: flex;
    margin-top: 10px;
  }
  /deep/ .type02-select-input .van-field{
    width: 200px;
  }

    /deep/ .van-rate__item {
    i {
      color: #117281 !important;
    }
  }
  img {
    width: 100%;
  }
}
.title-icon {
  position: relative;
  width: 12%;
  text-align: center;
  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
  }
}
.content {
  padding: 15px;
  background: #f1f1f1;
  .bar_title {
    display: flex;
    .title {
      position: relative;
      flex: 1;
      padding-left: 10px;
      vertical-align: middle;
      height: 50px;
      span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .questionType {
      width: 15%;
      line-height: 50px;
      text-align: center;
      color: #247181;
    }
  }
  .van-radio {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .van-checkbox {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .content_title {
    margin: 10px 0;
  }
}
.submit-btn {
  padding: 14px 0 24px;
  text-align: center;
  .van-button {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: #117281;
    border: none;
  }
}
.msg-pop {
  width: 200px;
  height: 135px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
  .msg-text {
    font-size: 14px;
    margin-top: 10px;
    color: #402d26;
    line-height: 22px;
  }
  .msg-btn {
    margin: auto;
    margin-top: 8px;
    width: 90px;
    height: 35px;
    border-radius: 8px;
    line-height: 35px;
    font-size: 14px;
  }
}
.msg-pop-join {
  height: 110px;
}
.msg-pop-error {
  width: 220px;
  height: 110px;
}
.score-content {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
}
.score {
  display: inline-block;
  width: 9%;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  background: #f1f1f1;
  border: 1px solid #cccccc;
  cursor: pointer;
}
.select {
  background-image: linear-gradient(#3b8c96, #23565d);
  color: #ffffff;
}
.content_title {
  padding: 0 15px;
}
.low-score {
  padding: 0 10px 10px 10px;
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 12px;
}
.van-radio {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.bg-radio-box {
  position: absolute;
  width: 158px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding-left: 45px;
}
.van-radio-box .van-radio {
  width: 158px;
  padding: 0;
  border: 1px solid #f5f5f5;
}
.van-radio .van-radio__label {
  margin-left: 0px;
}
.radio {
  position: relative;
  height: 20px;
  margin-bottom: 10px;
  background: #f7f7f7;
}
.radio-input {
  background: #f7f7f7;
  .van-radio__icon {
    display: none;
  }
}
.field-input {
  width: 100%;
  font-size: 12px;
  background: #f7f7f7;
  padding: 0px 0px 10px 0px;
}
.first-part{
    background-color:white;
    height: 100%;
    border-radius: 5px;
    .info-text{
      padding: 15px 10px;
      line-height: 20px;
    }
}
  .userType-title{
    background-color: #117281;
      color: white;
      padding: 5px;
  }
  .second-part{

    .info-text{

    background-color:white;
    height: 130px;
    border-radius: 5px;
    margin-bottom: 10px;
      padding: 15px 10px;
      line-height: 20px;
    }
}
</style>
<style>
.full-radio .van-radio__label {
  flex: 1;
}
.full-radio .van-cell {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio .van-radio__icon {
  z-index: 10;
}
.radio-input .van-radio__icon {
  display: none;
}
.van-radio__icon--checked + .van-radio__label > .bg-radio-box{
  background-image: linear-gradient(#3b8c96, #23565d);;
  color: #fff;
}
.van-radio__icon--checked .van-icon {
  border-color: #ffffff !important;
}
.field-input .van-field__control,
.score-field .van-field__control {
  height: auto !important;
}

.rate-score {
    margin-bottom: 8px;
    padding: 20px 20px;
  }
.rate-evaluation {
    position: relative;
    top: -4px;
    right: 0vw;
    color: #117281;
  }
  .rank{
    height: 50px;
    line-height: 30px;
  }
  .optionName{
    position: absolute;
    top: 2.5px;
    display: inline-block;
    left: 15px;
  }
  .rank-box{
    display: inline-block;
    position:absolute;
    top: 5px;
    width: 18px;
    height: 18px;
    border: 1px solid rgb(196, 196, 196);
    text-align: center;
    line-height: 18px;
  }
  .slider{
    height: 50px;
    margin:20px ;
  }
  .van-slider__bar{
    background-color: #117281;
  }
  .slider-text{
    font-size: 12px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  .rank-input{
    position: absolute;
    top: -5px;
    left: 72vw;
    display: inline-block;
  }
  .rank-input .van-cell{
    display: inline-block;
    padding: 0;
    width: 15px;
    position: relative;
    top: 7px;
  }
</style>
